const doc = [({"en":({"adminCancelPolicyOption":({"fixedFee":"The following cancellation fees apply", "free":"Free cancellation fee", "original":"Apply the cancellation policy"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;